// Subtitles aren't actually displayed in the overlay (they're part of the video)
// this div is just meant to occupy space so nothing overlaps with the subtitles

import { useCallback, useLayoutEffect, useRef, useState } from "react"
import styled from "styled-components"

import { useVideoContext } from "./VideoContext"

export const SubtitleArea = styled.div<{ $subtitleHeight: number }>`
  width: 100%;
  height ${(props) => props.$subtitleHeight}px;
  min-height: 50px;
  max-height: 80px;
`

export const SubtitlePlaceholderArea = () => {
  const { videoElement, subtitleBottom, setSubtitleBottom } =
    useVideoContext()
  const [subtitleHeight, setSubtitleHeight] = useState(0)
  const subtitleAreaRef = useRef<HTMLDivElement>(null)

  const recalculateHeightAndOffset = useCallback(() => {
    if (!videoElement || !subtitleAreaRef.current) {
      return
    }
    const subtitleAreaRect =
      subtitleAreaRef.current.getBoundingClientRect()

    const videoBottom = videoElement.getBoundingClientRect().bottom
    const subtitleAreaBottom = subtitleAreaRect.bottom

    const subtitleOffsetFromVideo = videoBottom - subtitleAreaBottom

    // 1. Let the video know about where the subtitles should be displayed
    if (subtitleBottom !== subtitleOffsetFromVideo) {
      setSubtitleBottom(subtitleOffsetFromVideo)
    }

    // 2. Determine our height so the subtitles all fit (and so we don't use too much height)
    // height = "default height" * ("default width" / "actual width")
    const newHeight = 50 * (800 / subtitleAreaRect.width)
    if (newHeight !== subtitleHeight) {
      setSubtitleHeight(newHeight)
    }
  }, [videoElement, setSubtitleBottom, setSubtitleHeight])

  // Every time the layout adjusts, so do we
  useLayoutEffect(() => {
    window.addEventListener("resize", recalculateHeightAndOffset)
    recalculateHeightAndOffset()
    return () =>
      window.removeEventListener("resize", recalculateHeightAndOffset)
  }, [recalculateHeightAndOffset])

  return (
    <SubtitleArea ref={subtitleAreaRef} $subtitleHeight={subtitleHeight} />
  )
}
